import * as yup from "yup";

const gameSummarySchema = yup.object().shape({
    plate: yup
        .object({
            overall: yup.number().optional().nullable(),
            consistency: yup.number().optional().nullable(),
            attitude: yup.number().optional().nullable(),
            effort: yup.number().optional().nullable(),
        })
        .optional(),
    field: yup
        .object({
            attitude: yup.number().optional().nullable(),
            effort: yup.number().optional().nullable(),
            overall: yup.number().optional().nullable(),
        })
        .optional(),
    scores: yup
        .object({
            home: yup
                .number()
                .nullable()
                .transform((curr, orig) => (orig === "" ? null : curr))
                .typeError("Score must be a number or empty"),
            visitor: yup
                .number()
                .nullable()
                .transform((curr, orig) => (orig === "" ? null : curr))
                .typeError("Score must be a number or empty"),
        })
        .optional(),
    pitchCounts: yup
        .object({
            home: yup
                .array(
                    yup.object().shape({
                        count: yup
                            .number()
                            .max(99, "Pitch count can not exceed 99")
                            .transform((value, originalValue) =>
                                originalValue === "" ? undefined : value,
                            )
                            .typeError(
                                "Please provide a pitch count value or remove this entry",
                            ),
                        player: yup
                            .object({
                                value: yup.number().required(),
                                label: yup.string().required(),
                            })
                            .optional(),
                    }),
                )
                .optional(),
            visitor: yup
                .array(
                    yup.object().shape({
                        count: yup
                            .number()
                            .max(99, "Pitch count can not exceed 99")
                            .transform((value, originalValue) =>
                                originalValue === "" ? undefined : value,
                            )
                            .typeError(
                                "Please provide a pitch count value or remove this entry",
                            ),
                        player: yup
                            .object({
                                value: yup.number().required(),
                                label: yup.string().required(),
                            })
                            .optional(),
                    }),
                )
                .optional(),
        })
        .optional(),
    homeSummary: yup.string().optional().nullable(),
    visitorSummary: yup.string().optional().nullable(),
});

export default gameSummarySchema;
